<template>
    <img class="logo" src="@/assets/img/logo.svg" alt="Base Apparel logo" />
</template>

<style lang="scss" scoped>
.logo {
    width: 170px;
    margin: 40px 0 100px 0;
    padding: 0 20px;
}
@media only screen and (max-width: $mobile) {
    .logo {
        margin-bottom: 40px;
    }
}
</style>
